export const CASUAL = 'CASUAL';
export const SUBSCRIPTION = 'SUBSCRIPTION';
export const TARIFF = 'TARIFF';
export const PURCHASE_BILL = 'PURCHASE_BILL';

// Константы входящих платежей
export const PURCHASE_TYPES = [
  'PURCHASE',
  'PURCHASE_BILL',
  'REFUND_DEBIT',
];

// Константы инициированного или успешного возврата
export const REFUND_ACTIVE_STATUSES = [
  'REFUND_SUCCESS',
  'REFUND_PROCESSING',
];

// Константы обозначений статусов безопасной сделки
export const SAFE_DEAL_STATUS_MAP = {
  'OPENED': 'safe.deal.status.opened',
  'CLOSED': 'safe.deal.status.closed',
  'CHALLENGE_PROCESSING': 'safe.deal.status.challenge.processing',
  'CHALLENGE_SUCCESS': 'safe.deal.status.challenge.success',
  'REFUND_PROCESSING': 'safe.deal.status.challenge.processing',
};

// Константы статусов открытой или спорной безопасной сделки
export const SAFE_DEAL_PROCESSING_STATUSES = [
  'OPENED',
  'CHALLENGE_PROCESSING',
];
